module.exports = __webpack_public_path__ + "static/media/IMG_1640.7a6532dc.JPG";